<script>
import { ref } from 'vue'
import { us_states , ASSETS_URL } from '../constants/envrionment';
import Magnify from 'vue-material-design-icons/Magnify.vue';
import ChevronDown from 'vue-material-design-icons/ChevronDown.vue';
import $ from 'jquery'

export default {
    components: { Magnify, ChevronDown },
    props:['selected'],
    setup(props) {
        
        return {
            search_val: ref(''),
            highlightState: ref(-1),
            highlightKey: ref(false),
            us_states: us_states,
            ASSETS_URL: ASSETS_URL,
        }
    },
    computed: {
        selectedState: function() {
            let str = ''

            if(this.selected){
                str = this.selected;
            }

            if(this.highlightKey){
                str = this.states_for_search[this.highlightState]['name']
            }

            return str
        },
        states_for_search: function() {
            let self = this,
                data = [];

            $.each(this.us_states,function(state,name){

                if(self.search_val){
                    if ((name.toLowerCase()).match(self.search_val)){
                        data.push({
                            value:state,
                            name:name
                        })                        
                    }
                }
                else{
                    data.push({
                        value:state,
                        name:name
                    })
                }
            });

            return data
        },
    },
    methods:{
        enterSelect: function(){

            if(this.highlightKey){
                
                this.$emit('select-state',this.states_for_search[this.highlightState])
            }
            
        },
        highlight: function(direction){

            this.highlightKey = true;

            if(direction == 'up'){
                if(this.highlightState > 0)
                    this.highlightState--;
            }
            else{
                if(this.highlightState < (this.states_for_search.length - 1))
                    this.highlightState++;
            }
            
            if($('.stateFilter .list .item.selected').length){
                $('.stateFilter .list').scrollTop($('.stateFilter .list').scrollTop() + $('.stateFilter .list .item.selected').position().top - $('.stateFilter .list').height()/2 + $('.stateFilter .list .item.selected').height()/2);
            }
        }
    },
    mounted: function(state){
        this.$refs.searchInput.focus();
    }
}

</script>

<template>
    <div class="stateFilter">
        <div class="title">
            <a @click.prevent="$emit('hide-search',1)" class="closeSearch" href="#"><ChevronDown /></a>
            <h3>Select state</h3>
        </div>
        <div class="search">
            <Magnify />
            <input ref="searchInput" type="text" placeholder="Search" name="text" v-model="search_val" @keyup.enter="enterSelect()" @keyup.up="highlight('up')" @keyup.down="highlight('down')" autocomplete="off" />
        </div>
        <TransitionGroup tag="div" name="list" class="list">
            <div ref="states" :class="{item:true,selected:selectedState==state.name}" v-for="state in states_for_search" :key="state.value" @click.prevent="$emit('select-state',state)" :data-state="state.value">
                <img :src="ASSETS_URL+'img/flags/'+state.value+'.png'" :alt="state.value" />
                <p>{{ state.name }}</p>
            </div>
        </TransitionGroup>
    </div>
</template>

<style scoped>

.list-enter-active,
.list-leave-active {
  transition: all 0.5s ease;
}
.list-enter-from,
.list-leave-to {
  opacity: 0;
  transform: translateX(30px);
}


</style>